import GlobirdSelector from 'components/Shared/GlobirdSelector';
import GlobirdSelectorOption from 'data/GlobirdSelectorOption';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchAllProductHistoryInfo, getCurrentAccountExistWolesaleAccountServices } from 'store/ProductHistoryInfoSlice';
import { selectCurrentAccount } from 'store/userSlice';

const menuOptions: GlobirdSelectorOption<string>[] = [
    { name: "Usage chart", value: "usagechart" },
    { name: "Upload self read", value: "selfread" },
    { name: "Download Wholesale Data", value: "wholesaledata" },
    // { name: "Previous meter read", value: "meterRead" }
];

const PropertyMenuOption: FC<{ defaultIndex: number, id: string }> = ({ defaultIndex, id }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentAccount = useSelector(selectCurrentAccount);
    const currentAccountExistWolesaleAccountServices = useSelector(getCurrentAccountExistWolesaleAccountServices);
    const [menuOptionsResult, setmenuOptionsResult] = useState<GlobirdSelectorOption<string>[]>(menuOptions);
    useEffect(() => {  
        if (!currentAccount?.services?.length) {      
            setmenuOptionsResult(menuOptions.filter(x => x.value !== 'wholesaledata'));
            return;
        }
        if(!currentAccountExistWolesaleAccountServices){
            dispatch(fetchAllProductHistoryInfo(currentAccount.accountId));
            setmenuOptionsResult(menuOptions.filter(x => x.value !== 'wholesaledata'));
            return;
        }

        if((currentAccountExistWolesaleAccountServices?.length ?? 0) === 0){     
            setmenuOptionsResult(menuOptions.filter(x => x.value !== 'wholesaledata'));
            return;
        }
        else{
            setmenuOptionsResult(menuOptions);
        }

    }, [currentAccount, currentAccountExistWolesaleAccountServices]);

    return <GlobirdSelector
    id={id}
    options={menuOptionsResult}
    defaultOption={menuOptionsResult[defaultIndex]}
    onSelected={(targetMenu) => { navigate(`/${targetMenu.value}`); }} />
}

export default PropertyMenuOption;
